// src/views/Users/Customers/Customers.jsx
import { useState, useEffect, useRef } from "react";
import { globalConstants, modeConstants } from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import ActionsDataTable from "../../../shared/ActionsDataTable";
import { userActions } from "../../../redux/actions";
import UserModal from "../../../shared/UserModal";
import NotificationModal from "../../../shared/NotificationModal";

export default function Notifications() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  // modal + row state
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [showNotificationModal, setshowNotificationModal] = useState(false);
  const [rowData, setRowData] = useState([]);
  const allData = useSelector((s) => s.userReducer.notifications);

  // filters aligned to table fields
  const filterColumns = [];

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1, // start from 1
      sortable: false,
      width: "100px",
    },
    {
      id: "alert_days_before",
      name: "Name",
      selector: (r) => r.alert_days_before,
      sortable: true,
      grow: 1.6,
    },
    // Actions
    {
      name: "Actions",
      sortable: false,
      width: "170px",
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              title="Edit"
              aria-label="Edit"
              onClick={() => {
                getRowData(row, modeConstants.UPDATE_MODE);
                setshowNotificationModal(true);
              }}
            >
              <i className="bi bi-pencil" />
            </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getRowData = (row, nextMode) => {
    dispatch(userActions.getNotificationById(row.id));
    setMode(nextMode);
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn.id} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(userActions.getNotifications());
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    // getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    getAll();
  }, []);

  return (
    <>
      <NotificationModal
        show={showNotificationModal}
        onHide={() => setshowNotificationModal(false)}
        mode={mode}
      />

      <ActionsDataTable
        columns={columns}
        filterColumns={filterColumns}
        data={rowData}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer={false}
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.length}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setShowModal={setshowNotificationModal}
        setMode={setMode}
        setGridState={setGridState}
        allowToolbar = {false}
      />
    </>
  );
}
